
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ThunderStormEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const scale = config.parallaxScale || 1.0;
        
        // Random flash
        const flash = this.pseudoRandom(Math.floor(time * 5)) > 0.95;
        if (flash) {
            ctx.save();
            ctx.globalAlpha *= 0.3 / layerIndex;
            ctx.fillStyle = pc.color;
            ctx.fillRect(-width * 2, -height * 2, width * 4, height * 4);
            ctx.restore();
        }

        const boltCount = Math.floor(1 * (config.parallaxComplexity || 1.0));
        ctx.strokeStyle = pc.color;
        
        for (let i = 0; i < boltCount; i++) {
            if (this.pseudoRandom(time + i) > 0.98) {
                const startX = (this.pseudoRandom(i) - 0.5) * width;
                const startY = -height;
                
                const draw = () => {
                    ctx.beginPath();
                    ctx.lineWidth = (3 / layerIndex) * scale;
                    ctx.moveTo(startX, startY);
                    let curX = startX;
                    let curY = startY;
                    while (curY < height) {
                        curX += (this.pseudoRandom(curY) - 0.5) * 100;
                        curY += 50;
                        ctx.lineTo(curX, curY);
                    }
                    ctx.stroke();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
